import api from "./api";

const create = (data) => {
  return api.post("/api/wo-form", data);
};

const findAll = (woId) => {
  return api.get("/api/wo-form", {
    params: {
      woId,
    },
  });
};

const findOne = (id) => {
  return api.get(`/api/wo-form/${id}`);
};

const update = (id, data) => {
  return api.patch(`/api/wo-form/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/api/wo-form/${id}`);
};

const getAllForms = (filters = {}) => {
  const params = {};
  if (filters.status !== undefined && filters.status !== "") params.status = filters.status;
  if (filters.formType !== undefined && filters.formType !== "") params.formType = filters.formType;
  if (filters.frequency !== undefined && filters.frequency !== "") params.frequency = filters.frequency;
  if (filters.woNumber !== undefined && filters.woNumber !== "") params.woNumber = filters.woNumber;
  if (filters.unassigned) params.unassigned = "true";
  if (filters.customerId) params.customerId = filters.customerId;
  return api.get("/api/wo-form/all-forms", { params });
};

// Aliases for consistency with existing service naming style.
const save = (data) => create(data);
const getAll = (woId) => findAll(woId);
const getById = (id) => findOne(id);
const deleteById = (id) => remove(id);

const WOFormService = {
  create,
  findAll,
  findOne,
  update,
  remove,
  save,
  getAll,
  getAllForms,
  getById,
  deleteById,
};

export default WOFormService;
